import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updatePersonApi } from "./personApi";

export const updatePersonRequest = createAsyncThunk(
  "updatePersonRequest/person",
  async (payload: any) => {
    try {
      const response = await updatePersonApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  personUpdate: any;
  message: string;
  pageIsLoading: boolean;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  personUpdate: {},
  message: "",
  pageIsLoading: false,
  isSuccess: false,
};

const personSlice = createSlice({
  name: "person",
  initialState: initialState,
  reducers: {
    resetPersonMessage: (state) => {
      state.message = "";
    },
    resetPersonSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // get job reducer
    builder.addCase(updatePersonRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updatePersonRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.personUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updatePersonRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetPersonMessage, resetPersonSuccess } = personSlice.actions;
export default personSlice.reducer;
